var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpen
    ? _c("div", [
        _c("div", {
          staticClass: "ma__overlay",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("toggle")
            },
          },
        }),
        _vm._v(" "),
        _c("div", { class: `ma__modalpopup ${_vm.className}` }, [
          _c(
            "div",
            { staticClass: "ma__content" },
            [
              _c(
                "div",
                {
                  staticClass: "ma__close",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("toggle")
                    },
                  },
                },
                [_c("span", [_vm._v("×")])]
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/Utilities/Modal.vue